export enum EmployerPages {
    START = 'Start',
    EMPLOYER = 'Employer',
    EMPLOYEE = 'Employee',
    BENEFITS = 'Benefits',
    CONTACT = 'Contact',
    OCCUPATION = 'Occupation',
    EMPLOYMENT = 'Employment',
    DEATH = 'Death',
    LIFE_BENEFITS = 'Life benefits',
    PRODUCT = 'Product',
    OTHER_LEAVE = 'Other leave',
    DOCUMENT = 'Document',
    CONDITION = 'Condition',
    EARNINGS = 'Earnings',
    PREMIUMS = 'Premiums',
    OTHER_INCOME = 'Other income',
    PAYMENTS = 'Payments',
    SUMMARY = 'Summary',
    FINISH = 'Finish'
}